export const TERMS_APPROVALS_TABLE_UNIQUE_ID = 'terms-approvals';

// How many agents are requested per scroll page.
export const TERMS_APPROVALS_PAGE_SIZE = 50;

export const TERMS_APPROVALS_COLUMN_WIDTHS: Record<string, number> = {
  'col-name': 170,
  'col-status': 70,
  'col-approved-at': 150
};
